import React from "react";
import { getGridVisibility } from "../utilities";
export const Grid = (props) => {
    const classes = getGridVisibility(props, false);
    return React.createElement("div", { className: `ms-Grid ${classes}`.trim(), style: props.style, "data-role": props.dataRole || '' }, props.children);
};
